import { HeadingItem } from '../../components/typography';
import type { ReactNode } from 'react';

type SectionTitleProps = {
  children: ReactNode;
};

export function SectionTitle({ children }: SectionTitleProps) {
  return <HeadingItem>{children}</HeadingItem>;
}
